import type { Placement } from '@floating-ui/utils';
import type { ComponentProps } from 'react';
import { type Tooltip } from 'react-tooltip';

export enum TooltipPlacement {
  Bottom = 'bottom',
  BottomStart = 'bottom-start',
  BottomEnd = 'bottom-end',
  Top = 'top',
  TopStart = 'top-start',
  TopEnd = 'top-end',
  Left = 'left',
  LeftStart = 'left-start',
  LeftEnd = 'left-end',
  Right = 'right',
  RightStart = 'right-start',
  RightEnd = 'right-end',
}

export const placementMap: Record<TooltipPlacement, ComponentProps<typeof Tooltip>['place']> = {
  [TooltipPlacement.BottomEnd]: 'bottom-end',
  [TooltipPlacement.BottomStart]: 'bottom-start',
  [TooltipPlacement.Bottom]: 'bottom',
  [TooltipPlacement.LeftEnd]: 'left-end',
  [TooltipPlacement.LeftStart]: 'left-start',
  [TooltipPlacement.Left]: 'left',
  [TooltipPlacement.RightEnd]: 'right-end',
  [TooltipPlacement.RightStart]: 'right-start',
  [TooltipPlacement.Right]: 'right',
  [TooltipPlacement.TopEnd]: 'top-end',
  [TooltipPlacement.TopStart]: 'top-start',
  [TooltipPlacement.Top]: 'top',
};

const topFallbackPlacements = [
  TooltipPlacement.Top,
  TooltipPlacement.TopEnd,
  TooltipPlacement.TopStart,
  TooltipPlacement.Bottom,
  TooltipPlacement.BottomEnd,
  TooltipPlacement.BottomStart,
];

const bottomFallbackPlacements = [
  TooltipPlacement.Bottom,
  TooltipPlacement.BottomEnd,
  TooltipPlacement.BottomStart,
  TooltipPlacement.Top,
  TooltipPlacement.TopEnd,
  TooltipPlacement.TopStart,
];

const leftFallbackPlacements = [
  TooltipPlacement.Left,
  TooltipPlacement.LeftEnd,
  TooltipPlacement.LeftStart,
  TooltipPlacement.Right,
  TooltipPlacement.RightEnd,
  TooltipPlacement.RightStart,
];

const rightFallbackPlacements = [
  TooltipPlacement.Left,
  TooltipPlacement.LeftEnd,
  TooltipPlacement.LeftStart,
  TooltipPlacement.Right,
  TooltipPlacement.RightEnd,
  TooltipPlacement.RightStart,
];

export const getAllowedPlacements = (placement: Placement): Placement[] => {
  if (placement.includes('top')) {
    return topFallbackPlacements;
  }
  if (placement.includes('bottom')) {
    return bottomFallbackPlacements;
  }
  if (placement.includes('left')) {
    return leftFallbackPlacements;
  }
  if (placement.includes('right')) {
    return rightFallbackPlacements;
  }
  return [];
};
